import { deleteMonotoringAndEvaluationModule } from '../../config/apiSinToken'

/**
 * AUTHOR: degrandezg@ngshn.com
 * DESCRIPTION: Delete form monitroing evaluation
 * FECHA: 7-2-2024
 */
export const deleteMonotoringAndEvaluation = async (idForm, B2C) => {
  const data = await deleteMonotoringAndEvaluationModule(
    `api/v1/MonitoringAndEvaluationQuestionnaireAnswers/Delete?IdForm=${idForm}&idUserB2C=${B2C}    `,
  )
  return data
}
